export const ADD_USER = 'ADD_USER'
export const BEGIN_ADD_USER = 'BEGIN_ADD_USER'
export const FINISH_ADD_USER = 'FINISH_ADD_USER'

export const ADD_IMAGE = 'ADD_IMAGE'
export const FINISH_ADD_IMAGE = 'FINISH_ADD_IMAGE'
export const BEGIN_ADD_IMAGE = 'BEGIN_ADD_IMAGE'

export const ADD_ENTRY = 'ADD_ENTRY'
export const FINISH_ADD_ENTRY = 'FINISH_ADD_ENTRY'
export const BEGIN_ADD_ENTRY = 'BEGIN_ADD_ENTRY '

export const EDIT_TRAINING_PLAN = 'EDIT_TRAINING_PLAN'

export const ADD_VIDEO_INFO = 'ADD_VIDEO_INFO'

export const FETCH_FOLDERS = 'FETCH_FOLDERS'
export const FINISH_FETCH_FOLDERS = 'FINISH_FETCH_FOLDERS'
export const BEGIN_FETCH_FOLDERS = 'BEGIN_ADD_FETCH_FOLDERS'

export const FETCH_VIDEOS = 'FETCH_VIDEOS'
export const FINISH_FETCH_VIDEOS = 'FINISH_FETCH_VIDEOS'
export const BEGIN_FETCH_VIDEOS = 'BEGIN_ADD_FETCH_VIDEOS'

export const FETCH_NEWS = 'FETCH_NEWS'
export const FINISH_FETCH_NEWS = 'FINISH_FETCH_NEWS'
export const BEGIN_FETCH_NEWS = 'BEGIN_FETCH_NEWS'

export const BEGIN_FETCH_USER_ALL_WATCHED_VIDEOS =
  'BEGIN_FETCH_USER_ALL_WATCHED_VIDEOS'
export const FETCH_USER_ALL_WATCHED_VIDEOS = 'FETCH_USER_ALL_WATCHED_VIDEOS'
export const FINISH_USER_ALL_WATCHED_VIDEOS = 'FINISH_USER_ALL_WATCHED_VIDEOS'

export const BEGIN_FETCH_USER_FOLDER_WATCHED_VIDEOS =
  'BEGIN_FETCH_USER_FOLDER_WATCHED_VIDEOS'
export const FETCH_USER_FOLDER_WATCHED_VIDEOS =
  'FETCH_USER_FOLDER_WATCHED_VIDEOS'
export const FINISH_USER_FOLDER_WATCHED_VIDEOS =
  'FINISH_USER_FOLDER_WATCHED_VIDEOS'

export const BEGIN_ADDING_DIET_PRODUCT_TO_CART =
  'BEGIN_ADDING_DIET_PRODUCT_TO_CART'
export const ADD_DIET_PRODUCT_TO_CART = 'ADD_DIET_PRODUCT_TO_CART'
export const FINISH_ADDING_DIET_PRODUCT_TO_CART =
  'FINISH_ADDING_DIET_PRODUCT_TO_CART'

export const ADD_UNLOCKED_MIAZGA_ID = 'ADD_UNLOCKED_MIAZGA_ID'
